/* eslint-disable max-len */
const availablePacks = [

]

module.exports = availablePacks
